import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useAuthorization } from "../../hooks/useAuthorization";
import Loading from "../../components/loading/Loading";
import Modal from "../../components/modal/Modal";
import MainContainer from "../../components/container/MainContainer";
import LocationHeader from "../../components/header/LocationHeader";
import Table from "../../components/tables/Table";
import { openModal } from "../../features/modalSLice";
import AddCurrency from "./AddCurrency";
import { getCurrencies, unsetCurrencies } from "../../features/currenciesSlice";
import { useLocation } from "react-router-dom";
import loadStatus from "../../util/loadStatus";
import NetworkError from "../error/NetworkError";

const Currency = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const modalContent = useSelector((state) => state.modal.content);
  const currencies = useSelector((state) => state.currencies.data);
  const loading = useSelector((state) => state.currencies.load.getCurrencies);
  const { isAuthorized } = useAuthorization();

  const title = "Currencies";
  // const links = [{ to: "/countries", name: "Countries" }];

  const columns = [
    { id: "num", text: "Num" },
    { id: "name", text: "Name" },
    { id: "symbol", text: "Symbol" },
    { id: "code", text: "Code" },
    { id: "country", text: "Country" },
  ];

  const openCurrencyModal = () => {
    dispatch(openModal(<AddCurrency />));
  };

  useEffect(() => {
    dispatch(getCurrencies());
    return () => {
      dispatch(unsetCurrencies());
    };
  }, []);

  if (loading === loadStatus.loading) {
    return <Loading />;
  }

  if (loading === loadStatus.error) {
    return <NetworkError to={location.pathname} />;
  }

  return (
    <>
      <Modal>{modalContent}</Modal>
      <MainContainer>
        <LocationHeader
          title={title}
          links={[]}
          action={openCurrencyModal}
          authorized={isAuthorized("settings", "create")}
        />
        <main className="table-container">
          <Table
            columns={columns}
            data={currencies}
            link
            // button={
            //   isAuthorized("currencies", "update")
            //     ? openEditCommunityModal
            //     : false
            // }
          />
        </main>
      </MainContainer>
    </>
  );
};

export default Currency;
